import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createStaticVNode as _createStaticVNode } from "vue";
const _hoisted_1 = {
  class: "container-fluid"
};
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<button class=\"navbar-toggler\" type=\"button\" data-bs-toggle=\"collapse\" data-bs-target=\"#navbarHead\" aria-controls=\"navbarHead\" aria-expanded=\"false\" aria-label=\"Toggle navigation\"><span class=\"navbar-toggler-icon\"></span></button><a class=\"navbar-brand text-truncate\" style=\"max-width:50%;\" href=\"/\"> Barcode Reader Demo </a><div class=\"collapse navbar-collapse\" id=\"navbarHead\"><ul class=\"navbar-nav me-auto mb-2 mb-lg-0\"><li class=\"nav-item\"><a class=\"nav-link active\" href=\"/\">Home</a></li></ul><a class=\"btn btn-dark\" href=\"https://github.com/rksan/barcode-detection-api-demo\" target=\"_blank\"><i class=\"bi bi-github\"></i> github </a></div>", 3);
const _hoisted_5 = {
  class: "dropdown"
};
const _hoisted_6 = /*#__PURE__*/_createElementVNode("button", {
  class: "btn btn-dark dropdown-toggle",
  type: "button",
  id: "dropdownMenuButton1",
  "data-bs-toggle": "dropdown",
  "aria-expanded": "false"
}, [/*#__PURE__*/_createElementVNode("i", {
  class: "bi bi-gear-fill"
})], -1);
const _hoisted_7 = {
  class: "dropdown-menu dropdown-menu-end",
  "aria-labelledby": "dropdownMenuButton1"
};
const _hoisted_8 = /*#__PURE__*/_createElementVNode("h1", null, "Settings", -1);
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_OSettings = _resolveComponent("OSettings");
  const _component_OSidebar = _resolveComponent("OSidebar");
  const _component_OModalDialog = _resolveComponent("OModalDialog");
  return _openBlock(), _createElementBlock(_Fragment, null, [_createElementVNode("nav", {
    class: _normalizeClass(["navbar navbar-expand-lg", $options.compTheme])
  }, [_createElementVNode("div", _hoisted_1, [_hoisted_2, _createElementVNode("div", _hoisted_5, [_hoisted_6, _createElementVNode("ul", _hoisted_7, [_createElementVNode("li", null, [_createElementVNode("button", {
    class: "dropdown-item",
    "data-bs-toggle": "offcanvas",
    "data-bs-target": "#settings-sidebar",
    "aria-controls": "settings-sidebar",
    onClick: _cache[0] || (_cache[0] = (...args) => _ctx.onSettings && _ctx.onSettings(...args))
  }, " Settings ")]), _createElementVNode("li", null, [_createElementVNode("button", {
    class: "dropdown-item",
    "data-bs-toggle": "modal",
    "data-bs-target": "#supported-constraints-dialog",
    onClick: _cache[1] || (_cache[1] = (...args) => $options.onSC && $options.onSC(...args))
  }, " Supported Constraints ")]), _createElementVNode("li", null, [_createElementVNode("button", {
    class: "dropdown-item",
    "data-bs-toggle": "modal",
    "data-bs-target": "#enumerate-devices-dialog",
    onClick: _cache[2] || (_cache[2] = (...args) => $options.onEnumerateDevices && $options.onEnumerateDevices(...args))
  }, " Enumerate Devices ")])])])])], 2), _createVNode(_component_OSidebar, {
    id: "settings-sidebar",
    theme: $props.theme,
    class: "offcanvas-end"
  }, {
    header: _withCtx(() => [_hoisted_8]),
    default: _withCtx(() => [_createVNode(_component_OSettings)]),
    _: 1
  }, 8, ["theme"]), _createVNode(_component_OModalDialog, {
    id: "supported-constraints-dialog",
    theme: $props.theme,
    title: "Supported Constraints"
  }, {
    default: _withCtx(() => [_createElementVNode("ul", null, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.supportedConstraints, (value, name, idx) => {
      return _openBlock(), _createElementBlock("li", {
        key: idx
      }, _toDisplayString(name) + " : " + _toDisplayString(value), 1);
    }), 128))])]),
    _: 1
  }, 8, ["theme"]), _createVNode(_component_OModalDialog, {
    id: "enumerate-devices-dialog",
    theme: $props.theme,
    title: "Enumerate Devices"
  }, {
    default: _withCtx(() => [_createElementVNode("ul", null, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.devices, (value, name, idx) => {
      return _openBlock(), _createElementBlock("li", {
        key: idx
      }, _toDisplayString(name) + " : " + _toDisplayString(value), 1);
    }), 128))])]),
    _: 1
  }, 8, ["theme"])], 64);
}